// 3rd party lib
import './gt_v4.js';

// Shared Modules
import {
    api,
} from '@shared/setups/api';

const validateResult = (captchaObj) => captchaObj.getValidate();

interface HandlerCallbacks {
    preValidationHandlerCallback?: (captchaObj) => void;
    readyCallback?: (res) => void;
    successCallback?: (res) => void;
    errorCallback?: (e) => void;
    closedCallback?: () => void;
}

interface GeeTestProps {
    product?: string;
    width?: string;
    lang?: string;
    area?: string;
}

const handler = (captchaObject, callbacks: HandlerCallbacks) => {
    captchaObject.onReady(() => {
        callbacks.readyCallback(captchaObject);
    });

    captchaObject.onSuccess(() => {
        callbacks.successCallback(validateResult(captchaObject));
    });

    captchaObject.onError((e) => {
        if (typeof callbacks.errorCallback === 'function') {
            callbacks.errorCallback(e);
        }
    });

    captchaObject.onClose(() => {
        if (typeof callbacks.closedCallback === 'function') {
            callbacks.closedCallback();
        }
    });

    if (typeof callbacks.preValidationHandlerCallback === 'function') {
        callbacks.preValidationHandlerCallback(captchaObject);
    }
};

export const geetestInit = async(
    {
        product = 'popup',
        width = '100%',
        lang = 'eng',
    } : GeeTestProps,
    callbacks: HandlerCallbacks,
) => {
    const result = await api.getGeetestCaptchaRegister();

    (<any>window).initGeetest4({
        captchaId: result.captchaId,
        product,
        language: lang,
        nextWidth: width,
        hideBar: 'close',
        protocol: 'https://',
        outside: false,
    }, (captchaObj) => handler(captchaObj, callbacks));
};